import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Container, Pagination, Paper, TextField, Typography, } from "@mui/material";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSearchPlayers } from "../ApiProvider";
import { Loading } from "../nav/Loading";
import { ErrorView } from "../nav/Error";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { PlayerSearchResultView } from "./PlayerSearchResultView";
export const SearchPlayerResults = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const currentSearchTerm = queryParams.get("q") || "";
    const currentPage = Number.parseInt(queryParams.get("page") || "1");
    const { data, isLoading, isError } = useSearchPlayers({
        searchTerm: currentSearchTerm,
        page: currentPage,
    });
    const handleChange = (_event, value) => {
        navigate(`/search/players?q=${encodeURIComponent(searchTerm)}&page=${value}`);
    };
    const [searchTerm, setSearchTerm] = useState(currentSearchTerm);
    const handleSearch = () => {
        navigate(`/search/players/?q=${encodeURIComponent(searchTerm)}`);
    };
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (!data) {
        return _jsx(ErrorView, {});
    }
    const { pageCount, results, count } = data;
    return (_jsxs(Container, { maxWidth: "md", style: { marginTop: "20px" }, children: [_jsx(ErrorSnackbar, { open: !!isError, message: "Failed to search for players!" }), _jsx(Typography, { variant: "h4", gutterBottom: true, children: "Player Search" }), _jsxs("div", { style: { display: "flex", gap: "10px", marginBottom: "20px" }, children: [_jsx(TextField, { variant: "outlined", label: "Search players", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), fullWidth: true, onKeyDown: (e) => {
                            if (e.key === "Enter") {
                                handleSearch();
                            }
                        } }), _jsx(Button, { variant: "contained", color: "primary", onClick: handleSearch, children: "Search" })] }), count === 0 && _jsx(Typography, { children: "No players found!" }), count > 0 ? (_jsxs(Paper, { children: [results.map((playerSearchResult, index) => (_jsx(Box, { display: "flex", alignItems: "center", padding: 2, bgcolor: index % 2 === 0 ? "#f9f9f9" : "#ffffff", borderBottom: "1px solid #ddd", children: _jsx(PlayerSearchResultView, { playerSearchResult: playerSearchResult }) }, playerSearchResult.id))), _jsx(Box, { display: "flex", justifyContent: "center", mt: 2, children: _jsx(Pagination, { showFirstButton: true, showLastButton: true, count: pageCount, page: currentPage, onChange: handleChange }) })] })) : null] }));
};
